var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',[_vm._v(" "+_vm._s(_vm.getPhaseIcon(_vm.item.data.phase))+" ")]),_vm._v(" "+_vm._s(_vm.item.data.status)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }